export default {
  getSopApplication: (state) => state.sopApplication
}
